import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { Checkbox  } from 'primereact/checkbox';

import { SET_VALUES_ADMIN } from '@constants/actionType';

import store from '@store';


class CountriesForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionCountriesVisible: [],
      isAllCountriesVisible: false,
      errors: [],
    };
  }

  componentDidMount() {
    const { _optionCountriesVisible, _isAllCountriesVisible } = this.props;

    if (_isAllCountriesVisible) {
      this.setState({ isAllCountriesVisible: _isAllCountriesVisible });
    }
    if (_optionCountriesVisible) {
      this.setState({ optionCountriesVisible: _optionCountriesVisible });
    }
    this.setState({ loadingPage: false });
  }

  

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeCheck = (e) => {
    const { optionCountriesVisible } = this.state
    const selectedCountry = [...optionCountriesVisible];
    if(e.checked)
      selectedCountry.push(e.value);
    else
      selectedCountry.splice(selectedCountry.indexOf(e.value), 1);

    this.setState(
      {optionCountriesVisible: selectedCountry, isAllCountriesVisible: false},
      () => this.validateFieldsOnchange(`countriesSelect`, true)
    );
  }

  onChangeAllCountries = (e) => {
    this.setState({isAllCountriesVisible: e.value, optionCountriesVisible: []}, () => this.validateFieldsOnchange(`countriesSelect`, true))
  }

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { t } = this.props
    const { isAllCountriesVisible, optionCountriesVisible } = this.state
    let errors = {}
    if (!isAllCountriesVisible && !optionCountriesVisible.length ) errors = { ...errors, [`countriesSelect`]: 'countriesSelect es requerido' }
    this.setState({errors})
    return errors
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { success } = this.props
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    await this.setValuesToStateGlobal();
    success()
  };

  setValuesToStateGlobal = async () => {
    const { isAllCountriesVisible, optionCountriesVisible } = this.state;


    await store.dispatch({
      type: SET_VALUES_ADMIN,
      payload: {
        isAllCountriesVisible,
        optionCountriesVisible
      }
    });
    return true
  };
  

  render() {
    const { t, btnSubmitLoading, user, countriesCatalog, onBack, isEdit } = this.props;

    const {
      loadingPage,
      errors,
      optionCountriesVisible
    } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderCountruiesOption = () => countriesCatalog.map(item => (
      <div className="p-field-checkbox" key={item.label}>
        <Checkbox
          inputId={`cb${item.id}`}
          name="optionCountriesVisible"
          value={item.id}
          onChange={this.onChangeCheck}
          checked={optionCountriesVisible.indexOf(item.id) !== -1}
          className={classNames({
            'p-invalid': isFormFieldValid(`countriesSelect`),
          })}
        />
        <label >{item.label}</label>
      </div>
    ))



    if (loadingPage) return true;

    return (
      <form onSubmit={this.onSubmit} autoComplete="false">
        <div className="p-fluid p-grid p-mb-4">
          <div className="p-col-6 p-mb-5">
            <label className="p-text-bold">{t('Nombre del usuario')}</label> <br/>
            <label>{user?.nombre || 'N/A'} </label>
          </div>
          <div className="p-col-12 p-field">
            <label  className="p-text-bold">{t('Seleccione el o los perfiles para el usuario')}</label> <br/>
          </div>
          <div className="p-col-12 p-field p-field-radiobutton">
            <Checkbox
              name="isAllCountriesVisible"
              value
              onChange={this.onChangeAllCountries}
              checked={this.state.isAllCountriesVisible}
              className={classNames({
                'p-invalid': isFormFieldValid(`countriesSelect`),
              })}
            />
            <label>{t('Todos los países')}</label>
          </div>
          <div className="p-col-12 p-field">
            { renderCountruiesOption() }
          </div>
        </div>
        <div className="p-col-12 footer-btn">
          <div className="p-d-flex p-jc-between">
            <Button
              label={t('Regresar')}
              type="button"
              className="p-button-secondary"
              onClick={() => onBack()}
            />
             <Button
             label={isEdit ? t('Actualizar administrador') : t('Continuar')}
             type="submit"
             className="p-button-primary"
             loading={btnSubmitLoading}
           />
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.admins.user,
  countriesCatalog: state.catalogs.countriesCurrentCatalog,
  _optionCountriesVisible: state.admins.optionCountriesVisible,
  _isAllCountriesVisible: state.admins.isAllCountriesVisible
});

const mapDispatchToProps = {
  
};


export default withRouter(compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(CountriesForm));
